import {SearchCriteria} from "./SearchCriteria";

export class RemedialSearchCriteria extends SearchCriteria {
  query?: string;
  status?: string;
  customerId?: number;
  userId?: string;
  teamData?: boolean;
  contractNumber?: number;
  createdDateFrom?: Date;
}
